import { createWidgetTracker } from '@src/services/analytics/widgetTracking';
import type { ProductBookingSlot } from '@src/domains/products/features/product-booking/types/productBookingSlot';

// Product Adder binding of the shared widget tracker. The generic events carry widget='product_adder'.
const tracker = createWidgetTracker('product_adder');

// Scope step guards/timers by widget instance AND product, so switching the embed's product-id
// re-arms tracking instead of reusing the previous product's guards/timers.
const instanceKey = (widgetId: string, productId: string) => `${widgetId}:${productId}`;

export const resetStepTracking = () => tracker.reset();

export const trackWidgetViewed = (productId: string, sellerId: string, hasLanguageStep: boolean) =>
  tracker.viewed({ product_id: productId, seller_id: sellerId, has_language_step: hasLanguageStep });

export const trackStepOpened = (widgetId: string, productId: string, slot: ProductBookingSlot, stepIndex: number) =>
  tracker.stepOpened(instanceKey(widgetId, productId), slot, stepIndex, { product_id: productId });

export const trackStepConfirmed = (widgetId: string, productId: string, slot: ProductBookingSlot) =>
  tracker.stepConfirmed(instanceKey(widgetId, productId), slot, { product_id: productId });

export const trackCtaClicked = (productId: string, totalPriceCents: number, stepsCount: number) =>
  tracker.ctaClicked({ product_id: productId, total_price_cents: totalPriceCents, steps_count: stepsCount });
